export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-shield-check-fill',
      title: 'Unbiased Reviews',
      description: 'We provide honest, independent reviews based on extensive testing and real player experiences.',
      color: 'from-blue-500 to-indigo-600'
    },
    {
      icon: 'ri-team-fill',
      title: 'Expert Team',
      description: 'Our team of casino experts has over 50 years of combined experience in the gaming industry.',
      color: 'from-purple-500 to-pink-600'
    },
    {
      icon: 'ri-time-fill',
      title: 'Updated Daily',
      description: 'We constantly monitor and update our reviews to ensure you have the latest information.',
      color: 'from-orange-500 to-red-600'
    },
    {
      icon: 'ri-customer-service-2-fill',
      title: '24/7 Support',
      description: 'Our dedicated support team is always available to help you with any questions or concerns.',
      color: 'from-green-500 to-emerald-600'
    }
  ];

  return (
    <section className="py-10 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center md:mb-16 mb-8">
          <h2 className="md:text-3xl text-2xl font-bold text-gray-900 mb-4">Why Choose KoalaBet?</h2>
          <p className="md:text-lg text-md text-gray-600 max-w-2xl mx-auto">
            We're committed to helping you find the best online casinos through transparent reviews and expert guidance
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div key={index} className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}